function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconCalendarAnniversaryFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 5h3a2 2 0 012 2v7H3V7a2 2 0 012-2h3V3h2v2h12V3h2v2zM5 12h22V7h-3v3h-2V7H10v3H8V7H5v5z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 27h22V16h2v11a2 2 0 01-2 2H5a2 2 0 01-2-2V16h2v11z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.172 19.133l-2.682-.369-1.144-2.54a.379.379 0 00-.692 0l-1.143 2.54-2.683.369a.381.381 0 00-.216.646l1.978 1.974-.496 2.798a.38.38 0 00.563.398L16 23.6l2.344 1.348a.38.38 0 00.562-.398l-.496-2.797 1.978-1.975a.38.38 0 00-.216-.646z",
    fill: props.color
  }));
}

export default SvgIconCalendarAnniversaryFilled;